import Variant1 from "./Variant1"
import Variant2 from "./Variant2"
import Variant3 from "./Variant3"
import Variant4 from './Variant4'
import Variant5 from './Variant5'
import Variant6 from './Variant6'
import Variant7 from './Variant7'

export const Indicators = {
    "variant1": {
        component: Variant1,
        image: "https://mobligo-bucket.s3.eu-central-1.amazonaws.com/1.png",
    },
    "variant2": {
        component: Variant2,
        image: "https://mobligo-bucket.s3.eu-central-1.amazonaws.com/2.png",
    },
    "variant3": {
        component: Variant3,
        image: "https://mobligo-bucket.s3.eu-central-1.amazonaws.com/3.png",
    },
    "variant4": {
        component: Variant4,
        image: "https://mobligo-bucket.s3.eu-central-1.amazonaws.com/4.png",
    },
    "variant5": {
        component: Variant5,
        image: "https://mobligo-bucket.s3.eu-central-1.amazonaws.com/5.png",
    },
    "variant6": {
        component: Variant6,
        image: "https://mobligo-bucket.s3.eu-central-1.amazonaws.com/6.png",
    },
    "variant7": {
        component: Variant7,
        image: "https://mobligo-bucket.s3.eu-central-1.amazonaws.com/7.png",
    },
}